import Http from '../services/Http';

export default class TourRepo{

    constructor($auth){
        this.http = new Http($auth);
        this.resource = 'tours';
    }

    get(data){
        return this.http.post(this.resource, data).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }
}


// WEBPACK FOOTER //
// ./src/repos/TourRepo.js